import { apiClient } from '@shared/api';
import type { ApiResponse } from '@shared/types';
import type {
  ReleaseListItemDto,
  ReleaseDto,
  CreateReleaseRequest,
  UpdateReleaseRequest,
} from '../types';

class ReleaseNoteService {
  async getPublished(): Promise<ReleaseListItemDto[]> {
    const { data } = await apiClient.get<ApiResponse<ReleaseListItemDto[]>>(
      '/release-notes',
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to fetch releases');
  }

  async getById(id: number): Promise<ReleaseDto> {
    const { data } = await apiClient.get<ApiResponse<ReleaseDto>>(
      `/release-notes/${id}`,
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to fetch release');
  }

  async getAllAdmin(): Promise<ReleaseListItemDto[]> {
    const { data } = await apiClient.get<ApiResponse<ReleaseListItemDto[]>>(
      '/release-notes/admin',
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to fetch releases');
  }

  async getByIdAdmin(id: number): Promise<ReleaseDto> {
    const { data } = await apiClient.get<ApiResponse<ReleaseDto>>(
      `/release-notes/admin/${id}`,
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to fetch release');
  }

  async create(request: CreateReleaseRequest): Promise<ReleaseDto> {
    const { data } = await apiClient.post<ApiResponse<ReleaseDto>>(
      '/release-notes',
      request,
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to create release');
  }

  async update(id: number, request: UpdateReleaseRequest): Promise<ReleaseDto> {
    const { data } = await apiClient.put<ApiResponse<ReleaseDto>>(
      `/release-notes/${id}`,
      request,
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to update release');
  }

  async delete(id: number): Promise<void> {
    const { data } = await apiClient.delete<ApiResponse<object>>(
      `/release-notes/${id}`,
    );
    if (!data.success) throw new Error(data.message || 'Failed to delete release');
  }
}

export const releaseNoteService = new ReleaseNoteService();
